import { createFileRoute } from "@tanstack/react-router";
import { OuvidoriaPage } from "@/components/pages/OuvidoriaPage";
import { KENTRO } from "@/lib/constants";

export const Route = createFileRoute("/ouvidoria")({
  head: () => ({
    meta: [
      { title: "Canal de Denúncias — Kentro Sistemas" },
      {
        name: "description",
        content:
          "Canal de Denúncias da Kentro Sistemas: registre elogios, reclamações, sugestões e denúncias de forma identificada ou anônima.",
      },
      { property: "og:title", content: "Canal de Denúncias — Kentro Sistemas" },
      {
        property: "og:description",
        content:
          "Comunicação direta entre colaboradores, parceiros e participantes da Kentro com a administração da organização.",
      },
      { property: "og:url", content: "https://kentro.com.br/ouvidoria" },
      { property: "og:locale", content: "pt_BR" },
    ],
    links: [
      { rel: "canonical", href: "https://kentro.com.br/ouvidoria" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://kentro.com.br/ouvidoria" },
      { rel: "alternate", hrefLang: "en", href: "https://kentro.com.br/en/ouvidoria" },
      { rel: "alternate", hrefLang: "es", href: "https://kentro.com.br/es/ouvidoria" },
      { rel: "alternate", hrefLang: "x-default", href: "https://kentro.com.br/ouvidoria" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Início", item: "https://kentro.com.br/" },
            { "@type": "ListItem", position: 2, name: "Canal de Denúncias", item: "https://kentro.com.br/ouvidoria" },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ContactPage",
          name: "Canal de Denúncias — Kentro Sistemas",
          url: "https://kentro.com.br/ouvidoria",
          inLanguage: "pt-BR",
          mainEntity: {
            "@type": "Organization",
            name: "Kentro Sistemas",
            contactPoint: [
              {
                "@type": "ContactPoint",
                contactType: "Canal de Denúncias",
                telephone: "+55-0800-550-2020",
                email: KENTRO.email,
                availableLanguage: "Portuguese",
                areaServed: "BR",
              },
            ],
          },
        }),
      },
    ],
  }),
  component: OuvidoriaPage,
});
